module.exports = __webpack_public_path__ + "static/media/wheel.e26c999c.png";